import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label,ButtonGroup } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { getEntity, updateEntity, createEntity, reset } from './rejection-reason.reducer';
import {hasAnyPermission} from "app/shared/auth/permissions";
import {getAllByType as getCountries} from "app/entities/region/region.reducer";
import {IRegion} from "app/shared/model/region.model";

export interface IRejectionReasonHFUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const IncidentReportUpdate = (props: IRejectionReasonHFUpdateProps) => {
  const { rejectionReasonHFEntity, countries, loading, updating, isAdmin, userCountryId } = props;
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);
  const [activeCountry, setActiveCountry] = useState<IRegion>({})
  const [driverCountryId, setDriverCountryId] = useState(null)
  const [activeStatus, setActiveStatus] = useState(true);


  const handleClose = () => {
    props.history.push('/rejection-reasons-hf');
  };


  useEffect(() => {
    if(!countries || countries.length === 0) {
      props.getCountries();
    }
  }, []);

  useEffect(() => {
    if (countries && countries.length > 0) {
      const ac = countries.find(country => country.id === userCountryId)
      setActiveCountry(ac)
    }
  }, [countries, userCountryId]);

  useEffect(() => {
    if (!isNew) {
      setActiveStatus(rejectionReasonHFEntity.isActive);
    }
  }, [rejectionReasonHFEntity]);

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }
  }, []);


  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const cid = isNew ? activeCountry?.id: rejectionReasonHFEntity.countryId;
      const country = countries.find(c => c.id === cid);


      const entity = {
        ...rejectionReasonHFEntity,
        ...values,
        isActive: activeStatus,
        country
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  const regCountriesList = countries.filter((ele)=>{
    return  isAdmin ? 1  : ele.id === activeCountry?.id;
  })

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="mmamaApp.rejectionReasonHF.home.createOrEditLabel">Create or edit a Rejection Reason (HF)</h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : rejectionReasonHFEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="rejection-reason-driver-reports-id">ID</Label>
                  <AvInput id="rejection-reason-driver-reports-id" type="text" className="form-control" name="id" required readOnly />
                </AvGroup>
              ) : null}

              <AvGroup>
                <Label id="isActive">
                  Active Status
                </Label>
                <ButtonGroup style={{ marginLeft: '30px' }}>
                  <Button
                    color={activeStatus ? 'primary' : 'secondary'}
                    onClick={(e) => {
                      setActiveStatus(true);
                    }}
                  >
                    Active
                  </Button>

                  <Button
                    color={!activeStatus ? 'primary' : 'secondary'}
                    onClick={() => {
                      setActiveStatus(false);
                    }}
                  >
                    Inactive
                  </Button>
                </ButtonGroup>
              </AvGroup>

              <AvGroup>
                <Label id="enConditionLabel" for="followup-enCondition">
                Rejection Reason (English)
                </Label>
                <AvField
                  id="followup-enCondition"
                  type="text"
                  name="enRejectionReason"
                  validate={{
                    required: { value: true, errorMessage: 'This field is required.' },
                  }}
                />
              </AvGroup>
              <AvGroup>
                <Label id="stConditionLabel" for="followup-stCondition">
                Rejection Reason (Local Language)
                </Label>
                <AvField
                  id="followup-stCondition"
                  type="text"
                  name="stRejectionReason"
                  validate={{
                    required: { value: true, errorMessage: 'This field is required.' },
                  }}
                />
              </AvGroup>

              {/* countries && countries.length > 0 && (
                <AvGroup>
                  <Label for="followup-country">Driver Country</Label>
                  <AvInput id="followup-country" type="select" className="form-control" name="rejectionReasonHFCountryId"  value = {isNew? driverCountryId: rejectionReasonHFEntity.rejectionReasonHFCountryId} >
                    {countries
                      ? countries.map(country => (
                        <option value={country.id} key={country.id}>
                          {country.name}
                        </option>
                      ))
                      : null}
                  </AvInput>
                </AvGroup>
              )*/}

              {regCountriesList && regCountriesList.length > 0 && (
                <AvGroup>
                  <Label for="followup-country">Country</Label>
                  <AvInput id="followup-country" type="select" className="form-control" name="countryId"  value = {isNew? activeCountry?.id: rejectionReasonHFEntity.countryId} >
                    {regCountriesList
                      ? regCountriesList.map(country => (
                        <option value={country.id} key={country.id}>
                          {country.name}
                        </option>
                      ))
                      : null}
                  </AvInput>
                </AvGroup>
              )

              }



              <Button tag={Link} id="cancel-save" to="/rejection-reasons-hf" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  rejectionReasonHFEntity: storeState.rejectionReasonHF.entity,
  loading: storeState.rejectionReasonHF.loading,
  updating: storeState.rejectionReasonHF.updating,
  updateSuccess: storeState.rejectionReasonHF.updateSuccess,
  countries: storeState.region.countries,
  userCountryId: storeState.authentication.userCountryId,
  isAdmin: hasAnyPermission(storeState.authentication.account.roles, ['ADMIN'])
});

const mapDispatchToProps = {
  getEntity,
  updateEntity,
  createEntity,
  reset,
  getCountries,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(IncidentReportUpdate);
